import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import Spinner from '../Spinner';
import BannerForm from './BannerForm';

const BannersNewForm = ({ from, onSuccess, onBack }) => {
  const fetch = useFetch();
  const [error, setError] = useState();
  const [segments, setSegments] = useState();
  const { accountId, domainId, pageId } = useParams();

  const [banner, setBanner] = useState();

  useEffect(() => {
    if (!from) {
      if (segments !== undefined) {
        setBanner({
          name: `New banner`,
          pageId,
          segmentId: segments[0]?.id,
          html: '',
          design: '',
          type: 'showAlways',
          editor: 'visual',
          reentryCooldownInDays: 7,
          reentryCooldownInHours: 0,
          reentrable: false,
          tags: [],
          segmentRelationship: 'and',
          inverseSegmentSelection: false,
          scope: 'banner',
        });
      }
    } else {
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/banners/${from}`)
        .then(({ banner }) => {
          setBanner({ ...banner, name: `Copy of ${banner.name}` });
        })
        .catch((error) => {
          setError(error);
        });
    }
  }, [fetch, accountId, domainId, from, segments, pageId]);

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/segments?scope=internal`)
      .then(({ segments }) => {
        setSegments(segments);
      })
      .catch((error) => {
        setError(error);
      });
  }, [fetch, accountId, domainId, pageId]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (banner === undefined || segments === undefined) {
    return <Spinner />;
  }

  return <BannerForm banner={banner} segments={segments} cancel={onBack} onSuccess={onSuccess} />;
};

export default BannersNewForm;
